import { LSL_USER_ID_COOKIE } from 'config/constants';
import jscookie from 'js-cookie';

const hasMemberIdCookie = () => {
  const memberId = jscookie.get(LSL_USER_ID_COOKIE);

  return !!memberId;
};

export default hasMemberIdCookie;
